import Image from 'next/image';
import { cn } from '@/utils/cn';
import { handleImageError } from '@/utils/image-error';
import { ColorType } from './types';
import WeightDisplay from '../pdp-components/weight-display';
type Props = {
  color: ColorType;
  weightUnit?: string | null;
  weightValue?: number | null;
};
export const BasketCardVariants = ({
  color,
  weightUnit,
  weightValue
}: Props) => {
  const hasColor = color?.name;
  const hasWeightValue = !!weightValue && weightValue > 0;
  const showSeparator = hasWeightValue && hasColor;
  if (!hasWeightValue && !hasColor) return null;
  return <div className='mt-1 flex items-center gap-4 lg:mt-2' data-sentry-component="BasketCardVariants" data-sentry-source-file="basket-card-variants.tsx">
            {hasWeightValue && <WeightDisplay unit={weightUnit ?? ''} value={weightValue} className={cn('relative text-caption-12 text-text-darkGray lg:text-body-14', {
      "after:absolute after:-left-2 after:top-1/2 after:block after:h-3 after:w-[1px] after:-translate-y-1/2 after:bg-gray-300 after:content-['']": showSeparator
    })} />}

            {!!hasColor && <div className='flex items-center gap-1'>
                    {color.image ? <Image src={color.image} alt={color.name} width={16} height={16} className='h-4 w-4 rounded-sm lg:h-5 lg:w-5 lg:rounded' unoptimized onError={handleImageError} /> : color?.hex && <div className='h-4 w-4 rounded-sm lg:h-5 lg:w-5 lg:rounded' style={{
        backgroundColor: color.hex
      }} />}

                    <span className='text-caption-12 text-text-darkGray lg:text-body-14'>{color.name}</span>
                </div>}
        </div>;
};